import React from 'react';

/**
 * QR Loyalty — the compact +/- stepper used across the loyalty settings
 * (points per visit/order, welcome bonus, table count). Shared so every stepper
 * is literally the same component + `.lty-stepper` styling.
 *
 * `step` opts into fractional values (the spend rate allows 0.5 points per
 * currency unit). It defaults to 1, where the maths below reduces to exactly the
 * integer behaviour every existing caller already had — parseInt, ±1, no
 * rounding — so adding it changes nothing for them.
 */
export default function LtyStepper({ value, min = 0, max = 100000, step = 1, onChange }) {
  const decimals = (String(step).split('.')[1] || '').length;
  const round = (n) => (decimals ? +n.toFixed(decimals) : n);
  const parse = (s) => (decimals ? parseFloat(s) : parseInt(s, 10));

  const v = Number.isFinite(+value) ? +value : 0;
  const clamp = (n) => round(Math.max(min, Math.min(max, Number.isFinite(n) ? n : 0)));

  return (
    <div className="lty-stepper">
      <button type="button" className="lty-step-btn" onClick={() => onChange(clamp(v - step))} aria-label="decrease">−</button>
      <input
        className="lty-step-val"
        type="number"
        inputMode={decimals ? 'decimal' : 'numeric'}
        step={step}
        value={v}
        onChange={(e) => onChange(clamp(parse(e.target.value)))}
      />
      <button type="button" className="lty-step-btn" onClick={() => onChange(clamp(v + step))} aria-label="increase">+</button>
    </div>
  );
}
